// App.js
import React from 'react';
import {Box} from "@mui/material";
import InvoiceForm from "./widgets/InvoiceForm";




export default function AddInvoiceScreen() {



    return (
        <Box sx={{ display: 'flex' }}>
            <Box width={"100%"}>
                <InvoiceForm formType={"new"}>

                </InvoiceForm>
            </Box>
        </Box>


    )
}